import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    type:     { type: String, default: "line" },
    labels:   Array,
    datasets: Array,
    options:  { type: Object, default: {} }
  }

  connect() {
    if (typeof Chart === "undefined") {
      setTimeout(() => this.initChart(), 150)
      return
    }
    this.initChart()
  }

  initChart() {
    if (typeof Chart === "undefined") return

    const isCartesian = ["line", "bar"].includes(this.typeValue)

    const defaults = {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 300 },
      plugins: {
        legend: {
          display: this.datasetsValue.length > 1,
          labels: {
            color: "#64748b",
            font: { family: "Inter", size: 12 },
            boxWidth: 10, padding: 14,
            usePointStyle: true, pointStyle: "circle"
          }
        },
        tooltip: {
          backgroundColor: "#1e293b",
          borderColor: "#334155",
          borderWidth: 1,
          titleColor: "#f1f5f9",
          bodyColor: "#94a3b8",
          padding: 10,
          cornerRadius: 6,
          titleFont: { family: "Inter", weight: "600", size: 12 },
          bodyFont:  { family: "Inter", size: 12 }
        }
      }
    }

    if (isCartesian) {
      defaults.scales = {
        x: {
          ticks:  { color: "#94a3b8", font: { family: "Inter", size: 11 }, maxTicksLimit: 8, maxRotation: 0 },
          grid:   { color: "rgba(0,0,0,0.05)" },
          border: { display: false }
        },
        y: {
          ticks:  { color: "#94a3b8", font: { family: "Inter", size: 11 } },
          grid:   { color: "rgba(0,0,0,0.05)" },
          border: { display: false },
          beginAtZero: true
        }
      }
    }

    const ctx = this.element.getContext("2d")
    this.chart = new Chart(ctx, {
      type: this.typeValue,
      data: { labels: this.labelsValue, datasets: this.datasetsValue },
      options: this.deepMerge(defaults, this.optionsValue)
    })
  }

  disconnect() {
    this.chart?.destroy()
  }

  deepMerge(target, source) {
    const result = { ...target }
    for (const key in source) {
      if (source[key] && typeof source[key] === "object" && !Array.isArray(source[key])) {
        result[key] = this.deepMerge(target[key] || {}, source[key])
      } else {
        result[key] = source[key]
      }
    }
    return result
  }
}
